import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "antd/dist/antd.css";
import "./index.css";
import { Layout } from "antd";
import { Navigation, routes } from "./Navigation";
import ObservationSearch from "./ObservationSearch";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import createMockServer from "./mock";

createMockServer();

const { Content, Footer } = Layout;

ReactDOM.render(
  <React.StrictMode>
    <Layout>
      <Router>
        <Navigation />
        <Content>
          <Switch>
            <Route path={routes.search}>
              <ObservationSearch />
            </Route>
            <Route path={routes.home}>
              <App />
            </Route>
          </Switch>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          Creado por <a href="https://codeness.io">Codeness</a> © 2020
        </Footer>
      </Router>
    </Layout>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
